import AgreementType from 'components/blocks/Delta/Inputs/AgreementType';
import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputIPF from 'components/blocks/ManagementNewForms/Inputs/FormInputIPF'; import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity';
import React, { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm, useWatch } from 'react-hook-form';
import get from 'lodash/get';
import FormInputTable from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import Loader from 'components/blocks/Loader/Loader';
import useCreatetCertificadoEmpresaIt from 'services/record/CertificadoEmpresa/useCreateCertificadoEmpresaIt';
import useUpdateCertificadoEmpresaItByID from 'services/record/CertificadoEmpresa/useUpdateCertificadoEmpresaItByID';
import FormInputRadioGroup from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioGroup';
import AccordionDisplay from 'components/blocks/ManagementNewForms/Accordion/AccordionDisplay';
import FormDoubleInput from 'components/blocks/ManagementNewForms/Inputs/FormDoubleInput';
import useCreateDeclaracionJuradaCeseActividadParcial from 'services/record/DeclaracionJuradaCeseActividadParcial/useCreateDeclaracionJuradaCeseActividadParcial';
import useUpdateDeclaracionJuradaCeseActividadParcialByID from 'services/record/DeclaracionJuradaCeseActividadParcial/useUpdateDeclaracionJuradaCeseActividadParcial';
import InputTextIntegration from 'components/blocks/ManagementNewForms/Inputs/InputTextIntegration';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';


const DeclaracionJuradaCeseActividadParcial = ({ info, dataUser, onSuccess }: { info: boolean; dataUser: any, onSuccess?: () => void }) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const { createDeclaracionJuradaCeseActividadParcial, dataCreateDeclaracionJuradaCeseActividadParcial, errorCreateDeclaracionJuradaCeseActividadParcial, loadingCreateDeclaracionJuradaCeseActividadParcial, successCreateDeclaracionJuradaCeseActividadParcial } = useCreateDeclaracionJuradaCeseActividadParcial();
    const { dataUpdateDeclaracionJuradaCeseActividadParcialById, errorUpdateDeclaracionJuradaCeseActividadParcialById, loadingUpdateDeclaracionJuradaCeseActividadParcialById, successUpdateDeclaracionJuradaCeseActividadParcialById, updateDeclaracionJuradaCeseActividadParcialById } = useUpdateDeclaracionJuradaCeseActividadParcialByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);
    const ingresosReferenciaCausa1 = useWatch({ control, name: 'DatosEconomicos.Causa1.IngresosReferencia' });
    const deudasExigiblesCausa2 = useWatch({ control, name: 'DatosEconomicos.Causa2.DeudasExigibles' });
    const ingresosReferenciaCausa2 = useWatch({ control, name: 'DatosEconomicos.Causa2.IngresosReferencia' });


    const adaptApiResponseToDefaultValues = (data: any) => {
        //console.log(data)
        if (data) {

            reset({
                DatosPersonales: {
                    SolicitanteNombre: data?.DatosPersonales?.Nombre || "",
                    SolicitanteApellido1: data?.DatosPersonales?.Apellido1 || "",
                    SolicitanteApellido2: data?.DatosPersonales?.Apellido2 || "",
                    SolicitanteIPF: data?.DatosPersonales?.IPF || "",
                    SolicitanteIPFTipo: data?.DatosPersonales?.IPFTipo?.toString() || "1",
                    SolicitanteNombreCompleto: data?.DatosPersonales?.Nombre + " " + data?.DatosPersonales?.Apellido1 + " " + data?.DatosPersonales?.Apellido2 || "",
                    SolicitanteTelefono: data?.DatosPersonales?.Telefono || "",
                    SolicitanteFijo: data?.DatosPersonales?.Fijo || "",
                    SolicitanteDomicilio: data?.DatosPersonales?.Domicilio || "",
                    SolicitanteCodigoPostal: data?.DatosPersonales?.CodigoPostal || "",
                    SolicitanteProvincia: data?.DatosPersonales?.CodigoProvincia || "",
                    SolicitanteProvinciaDescripcion: data?.DatosPersonales?.Provincia || "",
                    SolicitanteComunidadCodigo: data?.DatosPersonales?.ComunidadCodigo || "",
                    SolicitanteNumeroSS: data?.DatosPersonales?.NumeroSeguridadSocial || "",
                },
                // =====================================================
                // CESE ACTIVIDAD
                // =====================================================
                CeseActividad: {
                    Causas:
                        data?.CausaSeleccionada != null
                            ? data.CausaSeleccionada.toString()
                            : null,

                    FechaMotivoCese:
                        data?.FechaMotivo || null
                },

                // =====================================================
                // DATOS ECONÓMICOS – CAUSA 1
                // =====================================================
                DatosEconomicos: {
                    Causa1: {
                        TrimestresPrevios: [
                            data?.datosCausa1Trimestre1?.trimestresPrevios
                            ?? data?.DatosCausa1Trimestre1?.TrimestresPrevios
                            ?? data?.DatosCausa1?.TrimestresPrevios
                            ?? "",
                            data?.datosCausa1Trimestre2?.trimestresPrevios
                            ?? data?.DatosCausa1Trimestre2?.TrimestresPrevios
                            ?? data?.DatosCausa1?.TrimestresPrevios
                            ?? "",
                        ],

                        IngresosPrevios: [
                            data?.datosCausa1Trimestre1?.ingresosPrevios != null
                                ? data.datosCausa1Trimestre1.ingresosPrevios.toString()
                                : data?.DatosCausa1Trimestre1?.IngresosPrevios != null
                                    ? data.DatosCausa1Trimestre1.IngresosPrevios.toString()
                                    : data?.DatosCausa1?.IngresosPrevios != null
                                        ? data.DatosCausa1.IngresosPrevios.toString()
                                        : "",
                            data?.datosCausa1Trimestre2?.ingresosPrevios != null
                                ? data.datosCausa1Trimestre2.ingresosPrevios.toString()
                                : data?.DatosCausa1Trimestre2?.IngresosPrevios != null
                                    ? data.DatosCausa1Trimestre2.IngresosPrevios.toString()
                                    : data?.DatosCausa1?.IngresosPrevios != null
                                        ? data.DatosCausa1.IngresosPrevios.toString()
                                        : "",
                        ],

                        TrimestresReferencia: [
                            data?.datosCausa1Trimestre1?.trimestresReferencia
                            ?? data?.DatosCausa1Trimestre1?.TrimestresReferencia
                            ?? data?.DatosCausa1?.TrimestresReferencia
                            ?? "",
                            data?.datosCausa1Trimestre2?.trimestresReferencia
                            ?? data?.DatosCausa1Trimestre2?.TrimestresReferencia
                            ?? data?.DatosCausa1?.TrimestresReferencia
                            ?? "",
                        ],

                        IngresosReferencia: [
                            data?.datosCausa1Trimestre1?.ingresosReferencia != null
                                ? data.datosCausa1Trimestre1.ingresosReferencia.toString()
                                : data?.DatosCausa1Trimestre1?.IngresosReferencia != null
                                    ? data.DatosCausa1Trimestre1.IngresosReferencia.toString()
                                    : data?.DatosCausa1?.IngresosReferencia != null
                                        ? data.DatosCausa1.IngresosReferencia.toString()
                                        : "",
                            data?.datosCausa1Trimestre2?.ingresosReferencia != null
                                ? data.datosCausa1Trimestre2.ingresosReferencia.toString()
                                : data?.DatosCausa1Trimestre2?.IngresosReferencia != null
                                    ? data.DatosCausa1Trimestre2.IngresosReferencia.toString()
                                    : data?.DatosCausa1?.IngresosReferencia != null
                                        ? data.DatosCausa1.IngresosReferencia.toString()
                                        : "",
                        ],

                        calculo75Porciento: [
                            data?.datosCausa1Trimestre1?.calculo75Porciento != null
                                ? data.datosCausa1Trimestre1.calculo75Porciento.toString()
                                : data?.DatosCausa1Trimestre1?.Calculo75Porciento != null
                                    ? data.DatosCausa1Trimestre1.Calculo75Porciento.toString()
                                    : data?.DatosCausa1?.Calculo75Porciento != null
                                        ? data.DatosCausa1.Calculo75Porciento.toString()
                                        : "",
                            data?.datosCausa1Trimestre2?.calculo75Porciento != null
                                ? data.datosCausa1Trimestre2.calculo75Porciento.toString()
                                : data?.DatosCausa1Trimestre2?.Calculo75Porciento != null
                                    ? data.DatosCausa1Trimestre2.Calculo75Porciento.toString()
                                    : data?.DatosCausa1?.Calculo75Porciento != null
                                        ? data.DatosCausa1.Calculo75Porciento.toString()
                                        : "",
                        ],
                    },

                    // =====================================================
                    // DATOS ECONÓMICOS – CAUSA 2
                    // =====================================================
                    Causa2: {
                        TrimestresPrevios: [
                            data?.datosCausa2Trimestre1?.trimestresPrevios
                            ?? data?.DatosCausa2Trimestre1?.TrimestresPrevios
                            ?? data?.DatosCausa2?.TrimestresPrevios
                            ?? "",
                            data?.datosCausa2Trimestre2?.trimestresPrevios
                            ?? data?.DatosCausa2Trimestre2?.TrimestresPrevios
                            ?? data?.DatosCausa2?.TrimestresPrevios
                            ?? "",
                        ],

                        DeudasExigibles: [
                            data?.datosCausa2Trimestre1?.deudasExigibles != null
                                ? data.datosCausa2Trimestre1.deudasExigibles.toString()
                                : data?.DatosCausa2Trimestre1?.DeudasExigibles != null
                                    ? data.DatosCausa2Trimestre1.DeudasExigibles.toString()
                                    : data?.DatosCausa2?.DeudasExigibles != null
                                        ? data.DatosCausa2.DeudasExigibles.toString()
                                        : "",
                            data?.datosCausa2Trimestre2?.deudasExigibles != null
                                ? data.datosCausa2Trimestre2.deudasExigibles.toString()
                                : data?.DatosCausa2Trimestre2?.DeudasExigibles != null
                                    ? data.DatosCausa2Trimestre2.DeudasExigibles.toString()
                                    : data?.DatosCausa2?.DeudasExigibles != null
                                        ? data.DatosCausa2.DeudasExigibles.toString()
                                        : "",
                        ],

                        IngresosPrevios: [
                            data?.datosCausa2Trimestre1?.ingresosPrevios != null
                                ? data.datosCausa2Trimestre1.ingresosPrevios.toString()
                                : data?.DatosCausa2Trimestre1?.IngresosPrevios != null
                                    ? data.DatosCausa2Trimestre1.IngresosPrevios.toString()
                                    : data?.DatosCausa2?.IngresosPrevios != null
                                        ? data.DatosCausa2.IngresosPrevios.toString()
                                        : "",
                            data?.datosCausa2Trimestre2?.ingresosPrevios != null
                                ? data.datosCausa2Trimestre2.ingresosPrevios.toString()
                                : data?.DatosCausa2Trimestre2?.IngresosPrevios != null
                                    ? data.DatosCausa2Trimestre2.IngresosPrevios.toString()
                                    : data?.DatosCausa2?.IngresosPrevios != null
                                        ? data.DatosCausa2.IngresosPrevios.toString()
                                        : "",
                        ],

                        Calculo150Porciento: [
                            data?.datosCausa2Trimestre1?.calculo150Porciento != null
                                ? data.datosCausa2Trimestre1.calculo150Porciento.toString()
                                : data?.DatosCausa2Trimestre1?.Calculo150Porciento != null
                                    ? data.DatosCausa2Trimestre1.Calculo150Porciento.toString()
                                    : data?.DatosCausa2?.Calculo150Porciento != null
                                        ? data.DatosCausa2.Calculo150Porciento.toString()
                                        : "",
                            data?.datosCausa2Trimestre2?.calculo150Porciento != null
                                ? data.datosCausa2Trimestre2.calculo150Porciento.toString()
                                : data?.DatosCausa2Trimestre2?.Calculo150Porciento != null
                                    ? data.DatosCausa2Trimestre2.Calculo150Porciento.toString()
                                    : data?.DatosCausa2?.Calculo150Porciento != null
                                        ? data.DatosCausa2.Calculo150Porciento.toString()
                                        : "",
                        ],

                        TrimestresReferencia: [
                            data?.datosCausa2Trimestre1?.trimestresReferencia
                            ?? data?.DatosCausa2Trimestre1?.TrimestresReferencia
                            ?? data?.DatosCausa2?.TrimestresReferencia
                            ?? "",
                            data?.datosCausa2Trimestre2?.trimestresReferencia
                            ?? data?.DatosCausa2Trimestre2?.TrimestresReferencia
                            ?? data?.DatosCausa2?.TrimestresReferencia
                            ?? "",
                        ],

                        IngresosReferencia: [
                            data?.datosCausa2Trimestre1?.ingresosReferencia != null
                                ? data.datosCausa2Trimestre1.ingresosReferencia.toString()
                                : data?.DatosCausa2Trimestre1?.IngresosReferencia != null
                                    ? data.DatosCausa2Trimestre1.IngresosReferencia.toString()
                                    : data?.DatosCausa2?.IngresosReferencia != null
                                        ? data.DatosCausa2.IngresosReferencia.toString()
                                        : "",
                            data?.datosCausa2Trimestre2?.ingresosReferencia != null
                                ? data.datosCausa2Trimestre2.ingresosReferencia.toString()
                                : data?.DatosCausa2Trimestre2?.IngresosReferencia != null
                                    ? data.DatosCausa2Trimestre2.IngresosReferencia.toString()
                                    : data?.DatosCausa2?.IngresosReferencia != null
                                        ? data.DatosCausa2.IngresosReferencia.toString()
                                        : "",
                        ],

                        Calculo75Porciento: [
                            data?.datosCausa2Trimestre1?.calculo75Porciento != null
                                ? data.datosCausa2Trimestre1.calculo75Porciento.toString()
                                : data?.DatosCausa2Trimestre1?.Calculo75Porciento != null
                                    ? data.DatosCausa2Trimestre1.Calculo75Porciento.toString()
                                    : data?.DatosCausa2?.Calculo75Porciento != null
                                        ? data.DatosCausa2.Calculo75Porciento.toString()
                                        : "",
                            data?.datosCausa2Trimestre2?.calculo75Porciento != null
                                ? data.datosCausa2Trimestre2.calculo75Porciento.toString()
                                : data?.DatosCausa2Trimestre2?.Calculo75Porciento != null
                                    ? data.DatosCausa2Trimestre2.Calculo75Porciento.toString()
                                    : data?.DatosCausa2?.Calculo75Porciento != null
                                        ? data.DatosCausa2.Calculo75Porciento.toString()
                                        : "",
                        ],
                    }
                },
            })
        }

    }

    const parseInputNumber = (value: any) => {
        if (value === null || value === undefined || value === "") return null;
        if (typeof value === 'number') return Number.isFinite(value) ? value : null;

        const raw = String(value).trim().replace(/\s/g, '');
        if (!raw) return null;

        let normalized = raw;
        const hasComma = raw.includes(',');
        const hasDot = raw.includes('.');

        if (hasComma && hasDot) {
            normalized = raw.replace(/\./g, '').replace(',', '.');
        } else if (hasComma) {
            normalized = raw.replace(',', '.');
        }

        const parsed = Number(normalized);
        return Number.isFinite(parsed) ? parsed : null;
    };

    const calculate75Percent = (value: any) => {
        const parsed = parseInputNumber(value);
        if (parsed === null) return "";

        return Number((parsed * 0.75).toFixed(2)).toString();
    };

    const calculate150Percent = (value: any) => {
        const parsed = parseInputNumber(value);
        if (parsed === null) return "";

        return Number((parsed * 1.5).toFixed(2)).toString();
    };

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);

    useEffect(() => {
        const ingresos = Array.isArray(ingresosReferenciaCausa1)
            ? ingresosReferenciaCausa1
            : ["", ""];

        setValue('DatosEconomicos.Causa1.calculo75Porciento.0', calculate75Percent(ingresos[0]), {
            shouldValidate: false,
            shouldDirty: true,
            shouldTouch: false,
        });
        setValue('DatosEconomicos.Causa1.calculo75Porciento.1', calculate75Percent(ingresos[1]), {
            shouldValidate: false,
            shouldDirty: true,
            shouldTouch: false,
        });
    }, [ingresosReferenciaCausa1, setValue]);

    useEffect(() => {
        const deudas = Array.isArray(deudasExigiblesCausa2)
            ? deudasExigiblesCausa2
            : ["", ""];

        setValue('DatosEconomicos.Causa2.Calculo150Porciento.0', calculate150Percent(deudas[0]), {
            shouldValidate: false,
            shouldDirty: true,
            shouldTouch: false,
        });
        setValue('DatosEconomicos.Causa2.Calculo150Porciento.1', calculate150Percent(deudas[1]), {
            shouldValidate: false,
            shouldDirty: true,
            shouldTouch: false,
        });
    }, [deudasExigiblesCausa2, setValue]);

    useEffect(() => {
        const ingresos = Array.isArray(ingresosReferenciaCausa2)
            ? ingresosReferenciaCausa2
            : ["", ""];

        setValue('DatosEconomicos.Causa2.Calculo75Porciento.0', calculate75Percent(ingresos[0]), {
            shouldValidate: false,
            shouldDirty: true,
            shouldTouch: false,
        });
        setValue('DatosEconomicos.Causa2.Calculo75Porciento.1', calculate75Percent(ingresos[1]), {
            shouldValidate: false,
            shouldDirty: true,
            shouldTouch: false,
        });
    }, [ingresosReferenciaCausa2, setValue]);




    const onSubmit = async (data: any) => {
        // console.log(data);
        setLoader(true);

        let prestacionId = dataUser?.PrestacionId || null;
        const getTrimValue = (value: any, index: number) => Array.isArray(value) ? value[index] : null;
        const toNullable = (value: any) => (value === "" || value === undefined ? null : value);

        const datosEnvio = {
            // IDENTIFICACIÓN
            Id: dataUser?.Id || null,
            ExternalId: dataUser?.ExternalId || 0,
            PersonaId: dataUser?.PersonaId || 0,
            UsuarioId: dataUser?.UsuarioId || null,
            ExpedienteId: dataUser?.ExpedienteId || null,
            PrestacionId: prestacionId,

            Acepto: data?.Acepto ?? false,

            // -----------------------------------
            // DATOS PERSONALES
            // -----------------------------------
            DatosPersonales: {
                nombre: dataUser?.DatosPersonales?.Nombre ?? dataUser?.datosPersonales?.nombre ?? "",
                apellido1: dataUser?.DatosPersonales?.Apellido1 ?? dataUser?.datosPersonales?.apellido1 ?? "",
                apellido2: dataUser?.DatosPersonales?.Apellido2 ?? dataUser?.datosPersonales?.apellido2 ?? "",
                ipf: dataUser?.DatosPersonales?.IPF ?? dataUser?.datosPersonales?.ipf ?? "",
                ipfTipo: dataUser?.DatosPersonales?.IPFTipo ?? dataUser?.datosPersonales?.ipfTipo ?? 1,
                telefono: dataUser?.DatosPersonales?.Telefono ?? dataUser?.datosPersonales?.telefono ?? "",
                fijo: dataUser?.DatosPersonales?.Fijo ?? dataUser?.datosPersonales?.fijo ?? "",
                domicilio: dataUser?.DatosPersonales?.Domicilio ?? dataUser?.datosPersonales?.domicilio ?? "",
                codigoPostal: dataUser?.DatosPersonales?.CodigoPostal ?? dataUser?.datosPersonales?.codigoPostal ?? "",
                provinciaDescripcion: dataUser?.DatosPersonales?.ProvinciaDescripcion ?? dataUser?.DatosPersonales?.Provincia ?? dataUser?.datosPersonales?.provinciaDescripcion ?? "",
                codigoProvincia: dataUser?.DatosPersonales?.CodigoProvincia ?? dataUser?.datosPersonales?.codigoProvincia ?? "",
                codigoLocalidad: dataUser?.DatosPersonales?.CodigoLocalidad ?? dataUser?.datosPersonales?.codigoLocalidad ?? "",
                localidadDescripcion: dataUser?.DatosPersonales?.LocalidadDescripcion ?? dataUser?.datosPersonales?.localidadDescripcion ?? "",
                numeroSeguridadSocial: dataUser?.DatosPersonales?.NumeroSeguridadSocial ?? dataUser?.datosPersonales?.numeroSeguridadSocial ?? ""
            },
            // =====================================================
            // CESE / CAUSA
            // =====================================================
            CausaSeleccionada:
                data?.CeseActividad?.Causas != null
                    ? parseInt(data.CeseActividad.Causas)
                    : null,

            FechaMotivo:
                data?.CeseActividad?.FechaMotivoCese || null,

            // =====================================================
            // DATOS CAUSA 1 - TRIMESTRE 1 Y 2
            // =====================================================
            DatosCausa1Trimestre1: data?.CeseActividad?.Causas === "0" ? {
                TrimestresPrevios: toNullable(getTrimValue(data?.DatosEconomicos?.Causa1?.TrimestresPrevios, 0)),
                IngresosPrevios: toNullable(getTrimValue(data?.DatosEconomicos?.Causa1?.IngresosPrevios, 0)),
                TrimestresReferencia: toNullable(getTrimValue(data?.DatosEconomicos?.Causa1?.TrimestresReferencia, 0)),
                IngresosReferencia: toNullable(getTrimValue(data?.DatosEconomicos?.Causa1?.IngresosReferencia, 0)),
                Calculo75Porciento: toNullable(getTrimValue(data?.DatosEconomicos?.Causa1?.calculo75Porciento, 0)),
            } : null,
            DatosCausa1Trimestre2: data?.CeseActividad?.Causas === "0" ? {
                TrimestresPrevios: toNullable(getTrimValue(data?.DatosEconomicos?.Causa1?.TrimestresPrevios, 1)),
                IngresosPrevios: toNullable(getTrimValue(data?.DatosEconomicos?.Causa1?.IngresosPrevios, 1)),
                TrimestresReferencia: toNullable(getTrimValue(data?.DatosEconomicos?.Causa1?.TrimestresReferencia, 1)),
                IngresosReferencia: toNullable(getTrimValue(data?.DatosEconomicos?.Causa1?.IngresosReferencia, 1)),
                Calculo75Porciento: toNullable(getTrimValue(data?.DatosEconomicos?.Causa1?.calculo75Porciento, 1)),
            } : null,

            // =====================================================
            // DATOS CAUSA 2 - TRIMESTRE 1 Y 2
            // =====================================================
            DatosCausa2Trimestre1: data?.CeseActividad?.Causas === "1" ? {
                TrimestresPrevios: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.TrimestresPrevios, 0)),
                DeudasExigibles: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.DeudasExigibles, 0)),
                IngresosPrevios: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.IngresosPrevios, 0)),
                Calculo150Porciento: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.Calculo150Porciento, 0)),
                TrimestresReferencia: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.TrimestresReferencia, 0)),
                IngresosReferencia: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.IngresosReferencia, 0)),
                Calculo75Porciento: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.Calculo75Porciento, 0)),
            } : null,
            DatosCausa2Trimestre2: data?.CeseActividad?.Causas === "1" ? {
                TrimestresPrevios: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.TrimestresPrevios, 1)),
                DeudasExigibles: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.DeudasExigibles, 1)),
                IngresosPrevios: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.IngresosPrevios, 1)),
                Calculo150Porciento: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.Calculo150Porciento, 1)),
                TrimestresReferencia: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.TrimestresReferencia, 1)),
                IngresosReferencia: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.IngresosReferencia, 1)),
                Calculo75Porciento: toNullable(getTrimValue(data?.DatosEconomicos?.Causa2?.Calculo75Porciento, 1)),
            } : null,

            // =====================================================
            // DOCUMENTACIÓN
            // =====================================================
            documentacion: []
        }
        console.log(datosEnvio)
        if (info) {
            await createDeclaracionJuradaCeseActividadParcial(dataUser?.UsuarioId.toString(), datosEnvio, onSuccess)
            setBloquearEnvio(true);
        } else {
            await updateDeclaracionJuradaCeseActividadParcialById(dataUser?.Id, dataUser?.Id, datosEnvio)
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <Loader activeLoader={loader || loadingCreateDeclaracionJuradaCeseActividadParcial || loadingUpdateDeclaracionJuradaCeseActividadParcialById} label="Cargando Formulario"></Loader>








                {/* ////////////// COMIENZO FORMULARIO ////////////// */}




                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}

                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario ?? dataUser?.EstadoFormulario ?? dataUser?.estadoFormulario}
                    estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.estadoFormularioDescripcion ?? dataUser?.EstadoFormularioDescripcion ?? dataUser?.estadoFormularioDescripcion}
                    fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado ?? dataUser?.FechaActualizacionEstado ?? dataUser?.fechaActualizacionEstado}
                />

                <FieldsetContainer legend="" disabled={false}>
                    <p className='mt-2 mb-2 parra-bold'>En virtud de la prescripción recogida en el Título V “protección por cese de actividad” del RD Legislativo 8/2015 de 30 de octubre por el que se
                        aprueba el TRLGSS, en cuyo artículo 332 se determina la forma de acreditación de la situación legal de cese de la actividad en cada uno de los
                        supuestos tasados que se enumeran en el artículo 331 del mismo cuerpo legal, se certifica lo siguiente</p>
                    <p className='mt-2 mb-4 text-left parra-bold'>D./Dña
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteNombreCompleto"
                            inputType={1}
                            disabled={true}
                            minWidth={300}
                        />

                        con número de afiliación a la Seguridad Social
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteNumeroSS"
                            inputType={1}
                            disabled={true}
                        />
                        con DNI/NIF/pasaporte/NIE número
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteIPF"
                            inputType={1}
                            disabled={true}
                        />
                        y domicilio en
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteDomicilio"
                            inputType={1}
                            disabled={true}
                            minWidth={500}
                        />
                        en su condición de trabajador/a
                        autónomo/a declaro que no ha cesado en su actividad económica y se encuentra en alguna de las siguientes causas
                    </p>

                </FieldsetContainer>
                <div className='m-3'></div>


                <div className="row mb-4">
                    <div className="col-xl-12">


                        <FieldsetContainer legend="" disabled={false}>

                            <FormInputRadioGroup
                                title="Autónomo/a declaro que no ha cesado en su actividad económica y se encuentra en alguna de las siguientes causas"
                                name="CeseActividad.Causas"
                                required='Debe seleccionar una causa'
                                labels={["Causa 1ª: (Art. 331.1.a) 4ª RDL 8/2015 de 30 de octubre)", "Causa 2ª: (Art. 331.1.a) 5ª RDL 8/2015 de 30 de octubre)"]}
                                col={12}
                                modal={["La 60% de la jornada de la totalidad de las personas en situación de alta con obligación de cotizar de la empresa o suspensión temporal de los contratos de trabajo de al menos del 60% del número de personas en situación de alta con obligación de cotizar de la empresa siempre que los dos trimestres fiscales previos a la solicitud presentados ante la Administración tributaria, el nivel de ingresos ordinarios o ventas haya experimentado una reducción del 75 % de los registrados en los mismos periodos del ejercicio o ejercicios anteriores y los rendimientos netos mensuales del trabajador autónomo durante esos trimestres, por todas las actividades económicas, empresariales o profesionales, que desarrolle, no alcancen la cuantía del salario mínimo interprofesional o la de la base por la que viniera cotizando, si esta fuera inferior",
                                    "En el supuesto de trabajadores autónomos que no tengan trabajadores asalariados, el mantenimiento de deudas exigibles con acreedores cuyo importe supere el 150 % de los ingresos ordinarios o ventas durante los dos trimestres fiscales previos a la solicitud, y que estos ingresos o ventas supongan a su vez una reducción del 75 % respecto del registrado en los mismos períodos del ejercicio o ejercicios anteriores. A tal efecto no se computarán las deudas que por incumplimiento de sus obligaciones con la Seguridad Social o con la Administración tributaria mantenga. Se exigirá igualmente que los rendimientos netos mensuales del trabajador autónomo durante esos trimestres, por todas las actividades económicas o profesionales que desarrolle, no alcancen la cuantía del salario mínimo interprofesional o la de la base por la que viniera cotizando, si esta fuera inferior. A tal efecto no se computarán las deudas que por incumplimiento de sus obligaciones con la Seguridad Social o con la Administración tributaria mantenga."
                                ]}
                            />
                            <div className='m-3'></div>
                            <p>
                                Del mismo modo, hace constar que la fecha en la que se ha producido el motivo aducido es:
                                <InputTextIntegration
                                    name='CeseActividad.FechaMotivoCese'
                                    inputType={4}
                                    req='Debe seleccionar la fecha'
                                />
                            </p>
                            <div className='m-3'></div>
                            <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.Causas') === '0'} fields={['DatosEconomicos.Causa1.TrimestresPrevios', 'DatosEconomicos.Causa1.IngresosPrevios', 'DatosEconomicos.Causa1.TrimestresReferencia', 'DatosEconomicos.Causa1.IngresosReferencia', 'DatosEconomicos.Causa1.calculo75Porciento']}>
                                <p className='mt-2 mb-4'>Se ha producido una reducción interanual de al menos 75% de los ingresos ordinarios en los 2 trimestres fiscales
                                    previos presentados ante la Administración tributaria, conforme a los siguientes datos:</p>

                                <FormDoubleInput label={'A - Trimestres Fiscales Previos a la solicitud'} name={'DatosEconomicos.Causa1.TrimestresPrevios'} disabled={false} inputTypes={[1, 1]} double={true} modal={''} />
                                <FormDoubleInput label={'B- Ingresos de los trimestres fiscales previos a la solicitud'} name={'DatosEconomicos.Causa1.IngresosPrevios'} disabled={false} inputTypes={[3, 3]} double={true} modal={''} />
                                <FormDoubleInput label={'C -Trimestres fiscales del ejercicio o ejercicios anteriores de referencia para calcular la reducción de ingresos'} name={'DatosEconomicos.Causa1.TrimestresReferencia'} disabled={false} inputTypes={[1, 1]} double={true} modal={''} />
                                <FormDoubleInput label={'D -Ingresos de los trimestres fiscales del ejercicio o ejercicios anteriores de referencia para calcular la reducción de ingresos'} name={'DatosEconomicos.Causa1.IngresosReferencia'} disabled={false} inputTypes={[3, 3]} double={true} modal={''} />
                                <FormDoubleInput label={'E - Cálculo del 75% (del apartado D)'} name={'DatosEconomicos.Causa1.calculo75Porciento'} disabled={true} inputTypes={[3, 3]} double={true} modal={''} />

                                <p className='mt-4 mb-2'>Y los rendimientos netos mensuales durante esos trimestres (trimestres detallados en el apartado A anterior),
                                    por todas las actividades económicas, empresariales o profesionales, que desarrolle, no alcancen la cuantía
                                    del salario mínimo interprofesional o la de la base por la que viniera cotizando, si esta fuera inferior</p>
                            </AccordionDisplay>
                            <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.Causas') === '1'} fields={['DatosEconomicos.Causa2.TrimestresPrevios', 'DatosEconomicos.Causa2.DeudasExigibles', 'DatosEconomicos.Causa2.IngresosPrevios', 'DatosEconomicos.Causa2.Calculo150Porciento', 'DatosEconomicos.Causa2.TrimestresReferencia', 'DatosEconomicos.Causa2.IngresosReferencia', 'DatosEconomicos.Causa2.Calculo75Porciento']}>
                                <p className='mt-2 mb-4'>Mantenimiento de deudas exigibles con acreedores cuyo importe supere el 150 % de los ingresos ordinarios
                                    o ventas durante los dos trimestres fiscales previos a la solicitud.
                                    (Nota: A tal efecto no se computarán las deudas que por incumplimiento de sus obligaciones con la
                                    Seguridad Social o con la Administración tributaria mantenga)</p>

                                <FormDoubleInput label={'A - Trimestres Fiscales Previos a la solicitud'} name={'DatosEconomicos.Causa2.TrimestresPrevios'} disabled={false} inputTypes={[1, 1]} double={true} modal={''} />
                                <FormDoubleInput label={'B - Importe de deudas con acreedores durante los dos trimestres fiscales previos a la solicitud'} name={'DatosEconomicos.Causa2.DeudasExigibles'} disabled={false} inputTypes={[3, 3]} double={true} modal={''} />
                                <FormDoubleInput label={'C - Ingresos de los trimestres fiscales previos a la solicitud'} name={'DatosEconomicos.Causa2.IngresosPrevios'} disabled={false} inputTypes={[3, 3]} double={true} modal={''} />
                                <FormDoubleInput label={'D - Cálculo del 150% (del apartado B)'} name={'DatosEconomicos.Causa2.Calculo150Porciento'} disabled={true} inputTypes={[3, 3]} double={true} modal={''} />


                                <p className='mt-4 mb-2'>Cumplir requisito: B{'>'}D</p>

                                <p className='mt-4 mb-2'>y que estos ingresos o ventas supongan a su vez una reducción del 75% respecto del registrado en los mismos
                                    períodos del ejercicio o ejercicios anteriores.</p>

                                <FormDoubleInput label={'E - Trimestres fiscales del ejercicio o ejercicios anteriores de referencia para calcular la reducción de ingresos'} name={'DatosEconomicos.Causa2.TrimestresReferencia'} disabled={false} inputTypes={[1, 1]} double={true} modal={''} />
                                <FormDoubleInput label={'F - Ingresos de los trimestres fiscales del ejercicio o ejercicios anteriores de referencia para calcular la reducción de ingresos'} name={'DatosEconomicos.Causa2.IngresosReferencia'} disabled={false} inputTypes={[3, 3]} double={true} modal={''} />
                                <FormDoubleInput label={'G - Cálculo del 75% (del apartado F)'} name={'DatosEconomicos.Causa2.Calculo75Porciento'} disabled={true} inputTypes={[3, 3]} double={true} modal={''} />
                                <p className='mt-4 mb-2'> y los rendimientos netos mensuales durante esos trimestres (trimestres detallados en el apartado A anterior),
                                    por todas las actividades económicas, empresariales o profesionales, que desarrolle, no alcancen la cuantía
                                    del salario mínimo interprofesional o la de la base por la que viniera cotizando, si esta fuera inferior. </p>
                            </AccordionDisplay>
                        </FieldsetContainer>
                    </div>
                </div>

















                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreateDeclaracionJuradaCeseActividadParcial}
                    successUpdate={successUpdateDeclaracionJuradaCeseActividadParcialById}
                    errorCreate={errorCreateDeclaracionJuradaCeseActividadParcial}
                    errorUpdate={errorUpdateDeclaracionJuradaCeseActividadParcialById}
                    datosAPI={datosAPI}
                    info={info}
                    BloqueoForm={[1]}
                    label='
                    SOLICITO, mediante firma o documento acreditativo de la misma, del presente formulario que se me reconozca 
prestación ordinaria de cese de actividad para los trabajadores autónomos afectados por la reducción de la 
actividad regulada en el artículo 331.1.a) 4º y 5º de la Ley General de la Seguridad Social y suscribo para ello 
esta DECLARACIÓN RESPONSABLE incluida en este formulario
                    '>
                    <div className="info-interes-content">
                        <p className='mb-2'>                        <strong>Declaro, bajo mi responsabilidad </strong>, cumplir los requisitos de acceso a la prestación de cese por reducción parcial y temporal
                            de su actividad económica por la concurrencia de motivos económicos, técnicos, productivos u organizativos, por la causa
                            anteriormente seleccionada:
                        </p>
                        <p>
                            <strong>Me comprometo</strong>, bajo mi responsabilidad, a cumplir las siguientes obligaciones,
                            cuya infracción podría dar lugar al reintegro de la prestación indebidamente percibida:
                        </p>

                        <ul className="info-interes-list">
                            <li className="mb-2">
                                Permanecer de alta en el Régimen Especial correspondiente, ya que la baja en el mismo dará
                                lugar a la extinción de la prestación.
                            </li>

                            <li className="mb-2">
                                Comunicar a Solimat el acceso al derecho a cualquier otra prestación de la Seguridad Social
                                durante el cobro de la prestación ahora solicitada.
                            </li>

                            <li className="mb-2">
                                Aportar a Solimat la documentación que justifique los rendimientos netos mensuales percibidos
                                durante el cobro de la prestación solicitada en este documento.
                            </li>

                            <li className="mb-2">
                                Informar a Solimat de la reanudación de la actividad en condiciones normales, cuando se extinga
                                la causa que justificaba el cese temporal y parcial o cuando se dejen de cumplir los requisitos
                                establecidos para mantener la prestación.
                            </li>

                            <li className="mb-2">
                                Reintegrar a Solimat el importe de las cantidades percibidas como consecuencia de esta solicitud,
                                si durante su cobro se obtuvieran rendimientos netos que superen el límite de los ingresos
                                mensuales que dan derecho a la prestación.
                            </li>

                            <li className="mb-2">
                                Ingresar la cuota de cotización de autónomos que corresponda durante el período de percepción
                                de la prestación.
                            </li>
                        </ul>

                        <p className="mt-3">
                            <strong>MANIFIESTO </strong>, mi consentimiento para que mis datos profesionales de identificación personal y residencia
                            puedan ser consultados con garantía de confidencialidad, en el caso de acceso informatizado a dichos
                            datos, así como la verificación y cotejo de cualquier prestación de cese ordinaria de carácter temporal y
                            parcial de la actividad para los trabajadores autónomos afectados de la reducción de la actividad regulada

                            en el artículo 331.1.a) 4º y 5º de la Ley General de la Seguridad Social, a obtener de las bases de datos de
                            cualquier Organismo o Administración Pública. En particular, manifiesto mi autorización a la Administración de
                            Seguridad Social y a Soilmat para recabar de la administración tributaria correspondiente los datos tributarios
                            necesarios para la revisión del requisito de acceso y mantenimiento de la prestación.
                        </p>
                    </div>
                </FormBotonSubmit>


                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default DeclaracionJuradaCeseActividadParcial
